global.jQuery = global.$ = window.jQuery = require('jquery');
require('easing');
require('velocity');
require('TweenMax');
var ScrollMagic = require('ScrollMagic');
var skrollr = require('skrollr');
var Swiper = require('swiper');
require('inview');
require('image-map');

(function () {
	'use strict';
	$(function () {

		/*--------------------------------------------------------------------------*
		 * スムーズスクロール
		 *--------------------------------------------------------------------------*/
		$('a[href^="#"]' + 'a,area').click(function () {
			var speed = 500;
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top - 10;
			$("html, body").animate({
				scrollTop: position
			}, speed, "swing");
			return false;
		});

		/*--------------------------------------------------------------------------*
		 * inveiw
		 *--------------------------------------------------------------------------*/

		$('.js-view').css('opacity', '0');

		$('.js-view').on('inview', function () {
			$(this).delay(500).animate({
				opacity: '1'
			}, 1000);
		});

		$('.inviewchainwrap').on('inview', function (event, isInView) {
			if (isInView) {
				$(this).find('.inviewchain').each(function (i) {
					$(this).delay(500 * i).queue(function () {
						$(this).addClass('is-show').dequeue();
					});
				});
			}
		});

		/*---------------------------------------------
		ハンバーガーメニュー
		---------------------------------------------*/
		var flag = false,
			$navGlobal = $('.l-navGlobal'),
			$humberger = $('.c-humberger');

		$humberger.on('click', function () {
			if (!flag) {
				$humberger.addClass('is-active');
				$navGlobal.fadeIn(function () {
					flag = true;
				});
			} else {
				$humberger.removeClass('is-active');
				$navGlobal.fadeOut(function () {
					flag = false;
				});
			}
		});

		/*---------------------------------------------
		リンク消去
		---------------------------------------------*/
		$('.js-disable').click(function () {
			return false;
		});


		/*---------------------------------------------
		News
		---------------------------------------------*/
		var newsLink = $(".p-release__sort li");
		var newsLinkItem = $(".p-release .p-top-information__item");
		var limit = 99;
		newsLinkItem.css('display', 'none');
		for (var i = 0; i < limit; i++) {
			var limitNews = newsLinkItem[i];
			$(limitNews).fadeIn();
		}
		$(newsLink).click(function () {
			$(newsLink).removeClass("active");
			$(this).addClass("active");
			var btnFilter = $(this).attr('data-filter');
			if (btnFilter == 'catAll') {
				newsLinkItem.css('display', 'none');
				for (i = 0; i < limit; i++) {
					limitNews = newsLinkItem[i];
					$(limitNews).fadeIn();
				}
			} else {
				newsLinkItem.css('display', 'none');
				for (i = 0; i < limit; i++) {
					limitNews = newsLinkItem.filter('[data-category = "' + btnFilter + '"]')[i];
					$(limitNews).fadeIn();
				}
			}
		});


		/*---------------------------------------------
		History
		---------------------------------------------*/
		// nav fix
		var fix = $(".p-history__timeline");
		var fixTop = fix.offset().top;
		// スクロールイベントで判定
		$(window).scroll(function () {
			if ($(window).scrollTop() >= fixTop) {
				fix.addClass("fixed");
			} else {
				fix.removeClass("fixed");
			}
		});

		// nav active
		let scrollMenu = function () {
			// 配列宣言
			let array = {
				"#history01": 0,
				"#history02": 0,
				"#history03": 0,
				"#history04": 0,
				"#history05": 0,
			};

			let $globalNavi = new Array();

			// 各要素のスクロール値を保存
			for (let key in array) {
				if ($(key).offset()) {
					array[key] = $(key).offset().top - 10;
					$globalNavi[key] = $('.p-history__timeline ul li a[href="' + key + '"]');
				}
			}

			// スクロールイベントで判定
			$(window).on("scroll", function () {
				for (let key in array) {
					if ($(window).scrollTop() > array[key] - 50) {
						$(".p-history__timeline ul li a").each(function () {
							$(this).removeClass("active");
						});
						$globalNavi[key].addClass("active");
					}
				}
			});
		};

		scrollMenu();

	});

}).call(this);

/*---------------------------------------------
	skrollr setting
---------------------------------------------*/

var isMobile = false;

isMobile = $('html').is('.skrollr-mb');

if (!isMobile) {
	window.onload = function () {
		var s = skrollr.init({
			forceHeight: false,
			mobileDeceleration: 0.01,
			mobileCheck: function () {
				return isMobile;
			}
		});
	}
}


/*---------------------------------------------
	text
---------------------------------------------*/
// addClass時にイベントを起こす
(function () {
	// 元のmethodを保存
	var originalAddClassMethod = jQuery.fn.addClass;

	jQuery.fn.addClass = function () {
		// 元のmethodを実行
		var result = originalAddClassMethod.apply(this, arguments);

		// カスタムイベントを発火
		jQuery(this).trigger('cssClassAdd');

		return result;
	}
})();

// テキスト1文字ずつ表示
$('.movetext').each(function () {
	//一文字ずつ<span>で括る
	$(this).children().addBack().contents().each(function () {
		if (this.nodeType == 3) {
			$(this).replaceWith($(this).text().replace(/(\S)/g, '<span>$1</span>'));
		}
	});

	$(this).bind('cssClassAdd', function () {
		//一文字ずつ順番に不透明させる
		$(this).css({
			'opacity': 1
		});
		for (var i = 0; i <= $(this).children('span').length; i++) {
			$(this).children('span').eq(i).delay(100 * i).animate({
				'opacity': 1
			}, 800);
		};
	});
});


/*---------------------------------------------
	btn more
---------------------------------------------*/
$(function () {
	$('.c-btn_more').prevAll().hide();
	$('.c-btn_more').click(function () {
		$(this).prevAll().slideDown(500);
		$(this).addClass('close');
		$(this).fadeOut(500);
	});
});

/*---------------------------------------------
	swiper
---------------------------------------------*/
var topSlider = new Swiper('.p-top-slide', {
	initialSlide: 0,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	speed: 2000,
	autoplay: {
		delay: 2800,
	},
	spaceBetween: 0,
	effect: 'fade',
	loop: true,
	fadeEffect: {
		crossFade: true
	},
});


var swiper01 = new Swiper('.card01', {
	loop: true,
	slidesPerView: 1,
	centeredSlides: true,
	loopedSlides: 9,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});

var thumbs01 = new Swiper('.thumbs01', {
	slidesPerView: 'auto',
	centeredSlides: true,
	spaceBetween: 5,
	loop: true,
	slideToClickedSlide: true,
});

swiper01.controller.control = thumbs01;
thumbs01.controller.control = swiper01;

$(function () {
	// モーダル開く
	$('.card-item01').on('click', function () {
		var index = $('.card-item01').index(this); //クリックした要素のインデックスを取得
		swiper01.slideTo(index); //指定のスライドを呼び出し
		$('.modal01').addClass('is-show');
	});
	$('.p-modal__bg').on('click', function () {
		$('.modal01').removeClass('is-show');
	});
	$('.p-modal__btn').on('click', function () {
		$('.modal01').removeClass('is-show');
	});

});

// modal02
var swiper02 = new Swiper('.card02', {
	loop: true,
	slidesPerView: 1,
	centeredSlides: true,
	loopedSlides: 3,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});

var thumbs02 = new Swiper('.thumbs02', {
	slidesPerView: 'auto',
	centeredSlides: true,
	spaceBetween: 5,
	loop: true,
	slideToClickedSlide: true,
});

swiper02.controller.control = thumbs02;
thumbs02.controller.control = swiper02;

$(function () {
	// モーダル開く
	$('.card-item02').on('click', function () {
		var index = $('.card-item02').index(this); //クリックした要素のインデックスを取得
		swiper02.slideTo(index); //指定のスライドを呼び出し
		$('.modal02').addClass('is-show');
	});
	$('.p-modal__bg').on('click', function () {
		$('.modal02').removeClass('is-show');
	});
	$('.p-modal__btn').on('click', function () {
		$('.modal02').removeClass('is-show');
	});

});

// modal03
var swiper03 = new Swiper('.card03', {
	loop: true,
	slidesPerView: 1,
	centeredSlides: true,
	loopedSlides: 6,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});

var thumbs03 = new Swiper('.thumbs03', {
	slidesPerView: 'auto',
	centeredSlides: true,
	spaceBetween: 5,
	loop: true,
	slideToClickedSlide: true,
});

swiper03.controller.control = thumbs03;
thumbs03.controller.control = swiper03;

$(function () {
	// モーダル開く
	$('.card-item03').on('click', function () {
		var index = $('.card-item03').index(this); //クリックした要素のインデックスを取得
		swiper03.slideTo(index); //指定のスライドを呼び出し
		$('.modal03').addClass('is-show');
	});
	$('.p-modal__bg').on('click', function () {
		$('.modal03').removeClass('is-show');
	});
	$('.p-modal__btn').on('click', function () {
		$('.modal03').removeClass('is-show');
	});

});

// 画像の右クリック禁止
$(function () {
	$('.noclick').on('contextmenu', function (e) {
		return false;
	});
});